import request from '@/utils/request'

/**
 * 获取当前用户未确认的警戒线通知
 */
export function getUnconfirmedNotifies() {
  return request({
    url: '/notify/unconfirmedNotifies',
    method: 'get'
  })
}

/**
 * 确认单个警戒线通知
 */
export function confirmNotify(id) {
  return request({
    url: '/notify/confirm',
    method: 'post',
    params: { id }
  })
}

/**
 * 批量确认警戒线通知
 */
export function batchConfirmNotifies(ids) {
  return request({
    url: '/notify/batch-confirm',
    method: 'post',
    type: 'json',
    data: ids
  })
}

/**
 * 获取当前用户的所有警戒线通知历史（分页）
 */
export function getNotifyHistory(params) {
  return request({
    url: '/notify/history',
    method: 'get',
    params
  })
}

export function list(params) {
  return request({
    url: '/notify/list',
    method: 'get',
    params
  })
}
export function add(data) {
  return request({
    url: '/notify/add',
    method: 'post',
    type: "json",
    data
  })
}
export function edit(data) {
  return request({
    url: '/notify/edit',
    method: 'post',
    type: "json",
    data
  })
}
export function detail(params) {
  return request({
    url: '/notify/detail',
    method: 'get',
    params
  })
}
export function del(data) {
  return request({
    url: '/notify/delete',
    method: 'post',
    data
  })
}
